export const hardCodeIsFabricator = (subDomain, hardcodedSubDomains) => {
  if (!subDomain) {
    return false
  }
  const lowerCasedSubdomain = subDomain.toLowerCase();
  return hardcodedSubDomains.some(subDomainPart => lowerCasedSubdomain.includes(subDomainPart))
};

export const hardCodeIsLowes = (subDomain) => {
  return hardCodeIsFabricator(subDomain, ["mdp_surfaces", "lowes_", "/rona.", "rona_", "_rona", "rnodpt", "reno_depot"])
};

// export const hardCodeIsRona = (subDomain) => {
//   return hardCodeIsFabricator(subDomain, ["/rona.", "rona_"])
// };
//
// export const hardCodeIsRenoDepot = (subDomain) => {
//   return hardCodeIsFabricator(subDomain, ["rnodpt", "reno_depot"])
// };

export const hardCodeIsAmericanImport = (subDomain) => {
  // const subDomains = ['americanimport', 'americanstandard2020'];
  return hardCodeIsFabricator(subDomain, ["american"])
};

export const hardCodeIsMcDermott = (subDomain) => {
  return hardCodeIsFabricator(subDomain, ["mcdermott_", "mts_"])
};

export const hardCodeIsDeStefano = (subDomain) => {
  return hardCodeIsFabricator(subDomain, ["de_stefano", "de_stefano_new"])
};

export const hardCodeIsNhance = (subDomain) => {
  return hardCodeIsFabricator(subDomain, ["nhance"])
}

export const hardCodeIsKitchenMagic = (subDomain) => {
  return hardCodeIsFabricator(subDomain, ["kitchenmagic"])
}

export const hardCodeIsEncore = (subDomain) => {
  return hardCodeIsFabricator(subDomain, ["encore"])
}

export const hardCodeIsFloForm = (subDomain) => {
  return hardCodeIsFabricator(subDomain, ["floform"])
}

export const getAuthSubDomain = (auth, asCustomer) => {
  let subDomain = auth.subDomain || 'master';
  if (asCustomer && asCustomer.activeEntity) {
    const {activeEntity} = asCustomer;
    subDomain = activeEntity.subDomain;
  }
  return subDomain
}


